import { render, staticRenderFns } from "./MinutaTCATextoComponent.vue?vue&type=template&id=45dc8492&scoped=true&lang=pug"
import script from "./MinutaTCATextoComponent.vue?vue&type=script&lang=js"
export * from "./MinutaTCATextoComponent.vue?vue&type=script&lang=js"
import style0 from "./MinutaTCATextoComponent.vue?vue&type=style&index=0&id=45dc8492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc8492",
  null
  
)

export default component.exports